module.exports = __webpack_public_path__ + "static/media/number04.f4afd0fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/number04.svg
// module id = 930
// module chunks = 0